import axios from "axios";
import { encryptAES, decryptAES } from "../cryptoUtils";
import { getToken, clearToken } from "../context/tokenManager"; // ✅ Import the memory manager

// Create a custom axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});

// ✅ REQUEST INTERCEPTOR
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const sessionToken = getToken(); 
      if (sessionToken) {
        config.headers["Authorization"] = `Bearer ${sessionToken}`;
      }
      // console.log("Token Used in ApiClient: ", sessionToken)
    } catch (err) {
      console.error("Error fetching apg jwt token:", err);
    }

    // 2. Encrypt Payload safely
    if (config.method === "post" && config.data) {
      // Prevent double encryption just in case
      if (!config.data.encryptedRequest) {
        const plainDataString = JSON.stringify(config.data);
        const encryptedPayload = encryptAES(plainDataString);
        config.data = { encryptedRequest: encryptedPayload };
      }
    }
    
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ✅ RESPONSE INTERCEPTOR
apiClient.interceptors.response.use(
  (response) => {
    // Decrypt the response body safely
    if (response.data && response.data.encryptedResponse) {
      try {
        const decryptedString = decryptAES(response.data.encryptedResponse);
        response.data = JSON.parse(decryptedString);
      } catch (err) {
        console.error("Response decryption error:", err);
      }
    }
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors (Session invalid/Concurrent login)
    const message = error.response?.data?.detail;
    
    if (error.response?.status === 401 && message === "Session invalid or logged in from another device.") {
      alert("Unauthorised User Detected.");
      
      clearToken(); 
      localStorage.removeItem("ntid"); 
      window.location.href = "/";
      return; 
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;